<template>
  <div>
    <van-action-sheet v-model="visible" get-container="body" :title="title">
      <van-radio-group v-model="stagedValue">
        <van-cell-group :class="_.list">
          <van-cell
            v-for="item in data"
            :key="item.value"
            :title="item.label"
            clickable
            @click="handleItemClick(item)"
          >
            <template #right-icon>
              <van-radio :name="item.value" checked-color="#FF0F2A" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div v-if="!confirmOnPick" :class="_.actions">
        <x-button @click="handleConfirmClick">确定</x-button>
      </div>
    </van-action-sheet>
    <div @click="handleTriggerClick">
      <slot :label="label" :picked="label != null" />
    </div>
  </div>
</template>

<script>
  import Messenger from 'vue-messenger'
  import Vue from 'vue'
  import { wait } from 'vtils'

  export default Vue.extend({
    mixins: [Messenger],

    props: {
      title: {
        type: String,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      value: {
        type: null,
        required: true,
        on: {
          receive(value) {
            this.stagedValue = value
          },
        },
      },
      confirmOnPick: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      visible: false,
      stagedValue: null,
    }),

    computed: {
      isSingle() {
        return !Array.isArray(this.value)
      },
      label() {
        return this.isSingle
          ? this.data.find(item => item.value === this.value)?.label
          : this.data
              .filter(item => this.value.includes(item.value))
              .map(item => item.label)
      },
    },

    watch: {
      visible(visible) {
        if (!visible) {
          wait(500).then(() => {
            this.stagedValue = this.value
          })
        }
      },
    },

    methods: {
      handleTriggerClick() {
        if (this.disabled) return
        this.visible = true
      },
      handleItemClick(item) {
        this.stagedValue = item.value
        if (this.confirmOnPick) {
          this.handleConfirmClick()
        }
      },
      handleConfirmClick() {
        this.localValue = this.stagedValue
        this.visible = false
        this.$emit('confirm', this.localValue)
      },
    },
  })
</script>

<style lang="scss" module>
  .list {
    max-height: 50vh;
    overflow: auto;
  }

  .actions {
    padding: 16px;
  }
</style>
